var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.user_roles.is_root && _vm.link)?_c('div',{staticClass:"has-text-justified has-text-right mt-3"},[_c('b-button',{attrs:{"type":`is-outlined is-${_vm.topic}`,"expanded":""},on:{"click":function($event){return _vm.window.open(_vm.link, '_blank')}}},[_vm._v(" View "+_vm._s(_vm.reportName)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }